module.exports = __webpack_public_path__ + "./image/42a2b8c5494842875203742abc91fc7f.png";


//////////////////
// WEBPACK FOOTER
// ./images/home.png
// module id = 7
// module chunks = 0